import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

const CalendarContainer = () => {
  const [date, setDate] = useState(new Date());

  const onChange = (selectedDate) => {
    setDate(selectedDate);
  };

  return (
    <div>
      <div className="card mb-4">
        <div className="card-body">
          <div className="card-header">
            <h5 className="card-title">Calendario</h5>
          </div>
          <Calendar
            onChange={onChange}
            value={date}
            className="react-calendar"
          />
          <p className="mb-0 mt-3">Selected date: <strong>{date.toDateString()}</strong></p>
        </div>
      </div>
    </div>
  );
};

export default CalendarContainer;
